import React, {FunctionComponent} from "react";
import makeStyles from '@mui/styles/makeStyles';
import cs from "classnames";

type IconProps = {
    rotate?: boolean
}

export const CategoryArrow: FunctionComponent<IconProps> = ({rotate}) => {
    const classes = useStyles();

    return (
        <svg className={cs(classes.scale, {[classes.categoryRotate]: rotate})} width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0H10L5 9L0 0Z" fill="#FF6259"/>
        </svg>
    );
}

export const ParticipantArrow: FunctionComponent<IconProps> = ({rotate}) => {
    const classes = useStyles();

    return (
        <svg className={cs(classes.scale, {[classes.participantRotate]: rotate})} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle r="9" transform="matrix(1 0 0 -1 9 9)" fill="#5E85B1"/>
            <path d="M5 7L9 11L13 7" stroke="white"/>
        </svg>

    );
}
export const CurrentUserArrow: FunctionComponent<IconProps> = ({rotate}) => {
    const classes = useStyles();

    return (
        <svg className={cs(classes.scale, {[classes.currentPartipicantRotate]: rotate})} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle r="9" transform="matrix(1 0 0 -1 9 9)" fill="#FF6259"/>
            <path d="M7 13L11 9L7 5" stroke="white"/>
        </svg>

    );
}


const useStyles = makeStyles({
    scale: {
        transition: 'all .3s ease-in-out'
    },
    categoryRotate: {
        transform: 'rotate(180deg)'
    },
    participantRotate: {
        transform: 'rotate(-180deg)'
    },
    currentPartipicantRotate: {
        transform: 'rotate(-90deg)'
    }
});